export default __webpack_public_path__ + "static/media/CoralReader.179dbe33.png";